import { useLocation } from 'react-router-dom';
import { parse } from 'hub-http/helpers/params';
const defaultMapper = elem => elem;
const isAvailableTimelineLogItemType = val => {
  return ['PROPERTY_CHANGE', 'FORM_SUBMISSION', 'LIST_MEMBERSHIP', 'OBJECT_MERGE', 'FLOW_REVISION', 'UNIFIED_EVENT'].includes(val);
};
export const nanNumberMapper = val => {
  if (!Array.isArray(val)) {
    const mappedNum = Number(val);
    return isNaN(mappedNum) ? undefined : mappedNum;
  }
  return undefined;
};
export const pageNumberMapper = val => {
  if (!Array.isArray(val)) {
    const mappedNum = Number(val);
    return isNaN(mappedNum) ? 1 : mappedNum;
  }
  return 1;
};
export const availableLogTypeMapper = val => {
  if (Array.isArray(val)) {
    return val.filter(isAvailableTimelineLogItemType);
  }
  return isAvailableTimelineLogItemType(val) ? [val] : [];
};
export const sortDirectionMapper = val => {
  return val === 'ascending' || val === 'descending' ? val : 'none';
};
export default function useQueryParams(mappers) {
  const location = useLocation();
  const results = parse(location.search.substring(1));
  if (mappers) {
    return Object.keys(results).reduce((acc, param) => {
      const mapper = mappers[param] || defaultMapper;
      const value = results[param];
      return Object.assign({}, acc, {
        [param]: mapper(value)
      });
    }, {});
  }
  return results;
}